// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2541":"2389adce","9592":"b5668681"}[chunkId] + ".chunk.css";
};